export default __webpack_public_path__ + "static/media/spiral-notebook-img@2x.789e0f22.png";